import { SET_MODBUS_TEMPLATES } from './actiontypes';
import { getModbusTemplates } from '../../api/Api';

export const getModbusTemplatesAction =
  ({ force = false }) =>
  (dispatch, getState) => {
    const {
      user: { jwt },
      entities: {
        modbus: { templates },
      },
    } = getState();

    if (!force && Object.keys(templates).length > 0) return Promise.resolve();
    return getModbusTemplates(jwt).then((data) =>
      dispatch({ type: SET_MODBUS_TEMPLATES, data: data.templates })
    );
  };
